import React, { useState } from "react";

export default function VerifyCustStatusButton({ token, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleVerify = async () => {
    if (!window.confirm("Verify customer status sekarang?")) return;

    setLoading(true);
    setError(null);

    try {
      const res = await fetch("https://api.wifikamu.my.id/cust-status/verify", {
        method: "GET",
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      });

      const body = await res.json();

      if (!res.ok || !body.success) {
        throw new Error(body.message || "Verify failed");
      }

      alert(
        `Verification completed\n\nTotal customers SKI: ${body.meta.total_customers}\nUpdated rows SKI: ${body.meta.updated_rows}`
      );

      if (onSuccess) onSuccess();
    } catch (err) {
      console.error("VerifyCustStatus error:", err);
      setError(err.message);
      alert(`Error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col">
      <button
        onClick={handleVerify}
        disabled={loading}
        className={`px-3 py-2 rounded-md text-sm font-medium shadow-sm
          ${
            loading
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-indigo-600 hover:bg-indigo-700 text-white"
          }`}
      >
        {loading ? "Verifying..." : "Verify Customers Status"}
      </button>

      {error && <span className="mt-1 text-xs text-red-500">{error}</span>}
    </div>
  );
}
